module.exports = __webpack_public_path__ + "static/media/icon_alert_no_verif_new_x1.05326b48.png";